export const SET_AUTH = 'SET_AUTH';
export const SET_CHALLENGE = 'SET_CHALLENGE';
export const CLEAR_CHALLENGE = 'CLEAR_CHALLENGE';
export const CLEAR_AUTH = 'CLEAR_AUTH';
export const CLEAR_USER_POOL_ID = 'CLEAR_USER_POOL_ID';
export const CLEAR_LOGIN_DOMAIN = 'CLEAR_LOGIN_DOMAIN';
export const FIND_USER_POOL_ID = 'FIND_USER_POOL_ID';
export const FIND_USER_POOL_CLIENT_ID = 'FIND_USER_POOL_CLIENT_ID';
export const SET_LOGIN_DOMAIN = 'SET_LOGIN_DOMAIN';
export const DELETE_USER_POOL = 'DELETE_USER_POOL';
export const SET_PREFILL_DATA = 'SET_PREFILL_DATA';
export const CLEAR_PREFILL_DATA = 'CLEAR_PREFILL_DATA';
